import comp from "./Main";

export default comp;
